/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ledger_Query_SavedInputs */

const en_ledger_query_saved = /** @type {(inputs: Ledger_Query_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Source query saved`)
};

const nl_ledger_query_saved = /** @type {(inputs: Ledger_Query_SavedInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Bronquery opgeslagen`)
};

/**
* | output |
* | --- |
* | "Source query saved" |
*
* @param {Ledger_Query_SavedInputs} inputs
* @param {{ locale?: "en" | "nl" }} options
* @returns {LocalizedString}
*/
export const ledger_query_saved = /** @type {((inputs?: Ledger_Query_SavedInputs, options?: { locale?: "en" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ledger_Query_SavedInputs, { locale?: "en" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "nl") return nl_ledger_query_saved(inputs)
	return en_ledger_query_saved(inputs)
});